import { InfoIcon } from 'lucide-react';
import { Tooltip } from '../../../../UiKit';

/**
 * form field info tooltip component
 * @component
 */
export const getHeaderWithTooltip = (title, tip) => {
  return (
    <div className='tw-flex tw-items-center tw-gap-2 tw-font-medium tw-text-[1.4rem] tw-mb-3 tw-text-zinc-700'>
      {title}
      {tip && (
        <Tooltip
          position='bottom'
          border={false}
          title={<InfoIcon size={16} />}
          label={tip}
        />
      )}
    </div>
  );
};
